module.exports = __webpack_public_path__ + "img/Weapon_160.6ccfd346.png";